// Generated by purs version 0.15.15
import * as Control_Monad_Except_Trans from "../Control.Monad.Except.Trans/index.js";
import * as Data_Functor from "../Data.Functor/index.js";
import * as Data_Identity from "../Data.Identity/index.js";
import * as Data_MultiSet from "../Data.MultiSet/index.js";
import * as Data_Newtype from "../Data.Newtype/index.js";
import * as Foreign_Generic_Class from "../Foreign.Generic.Class/index.js";
import * as Unscramble from "../Unscramble/index.js";
var wrap = /* #__PURE__ */ Data_Newtype.wrap();
var unwrap = /* #__PURE__ */ Data_Newtype.unwrap();
var map = /* #__PURE__ */ Data_Functor.map(/* #__PURE__ */ Control_Monad_Except_Trans.functorExceptT(Data_Identity.functorIdentity));
var MultiSet = function (x) {
    return x;
};
var showMultiSet = function (dictShow) {
    return Data_MultiSet.showMultiSet(dictShow);
};
var semigroupMultiSet = function (dictOrd) {
    return Data_MultiSet.semigroupMultiSet(dictOrd);
};
var ordMultiSet = function (dictOrd) {
    return Data_MultiSet.ordMultiSet(dictOrd);
};
var newtypeMultiSet = {
    Coercible0: function () {
        return undefined;
    }
};
var udecodeMultiSet = function (dictOrd) {
    var fromArray = Data_MultiSet.fromArray(dictOrd);
    return function (dictDecode) {
        return {
            unsafeDecode: (function () {
                var $28 = Unscramble.unsafeDecode(Unscramble.decodeArray1(dictDecode));
                return function ($29) {
                    return wrap(fromArray($28($29)));
                };
            })()
        };
    };
};
var monoidMultiSet = function (dictOrd) {
    return Data_MultiSet.monoidMultiSet(dictOrd);
};
var eqMultiSet = function (dictEq) {
    return Data_MultiSet.eqMultiSet(dictEq);
};
var encodeMultiSet = function (dictEncode) {
    return {
        encode: (function () {
            var $30 = Foreign_Generic_Class.encode(Foreign_Generic_Class.arrayEncode(dictEncode));
            return function ($31) {
                return $30(Data_MultiSet.elems(unwrap($31)));
            };
        })()
    };
};
var decodeMultiSet = function (dictOrd) {
    var fromArray = Data_MultiSet.fromArray(dictOrd);
    return function (dictDecode) {
        return {
            decode: (function () {
                var $32 = map(function ($35) {
                    return wrap(fromArray($35));
                });
                var $33 = Foreign_Generic_Class.decode(Foreign_Generic_Class.arrayDecode(dictDecode));
                return function ($34) {
                    return $32($33($34));
                };
            })()
        };
    };
};
export {
    MultiSet,
    newtypeMultiSet,
    eqMultiSet,
    ordMultiSet,
    showMultiSet,
    semigroupMultiSet,
    monoidMultiSet,
    encodeMultiSet,
    decodeMultiSet,
    udecodeMultiSet
};
